/* Capitol style — nút "Add to cart" trên thẻ sản phẩm gv-* (không mở trang mới).
   Như GovMint: Adding... → Added (1 giây) → trở lại. Báo cho giỏ hàng Horizon (số trên icon, ngăn kéo giỏ hàng)
   bằng đúng sự kiện chuẩn mà theme dùng. Không có JS thì form vẫn gửi bình thường tới /cart/add.
   Nghe 'submit' ở pha capture trên window: chặn mặc định TRƯỚC bộ theo dõi của Shopify (Web Pixels),
   nếu không Shopify đếm 2 lần product_added_to_cart (1 lần do form submit, 1 lần do request /cart/add.js).
   Thêm thành công → mở giỏ hàng nhanh (gv-minicart) bằng khung Shopify trả kèm, không tải thêm. */
const busy = new WeakSet();

async function cartEvent() {
  try { return (await import('@shopify/events')).CartLinesUpdateEvent || null; } catch (_) { return null; }
}

window.addEventListener('submit', async (e) => {
  const form = e.target instanceof HTMLFormElement && e.target.matches('form[data-gv-add]') ? e.target : null;
  if (!form) return;
  e.preventDefault();
  const btn = form.querySelector('.gv-deal__btn');
  if (!btn || btn.disabled || busy.has(form)) return;
  busy.add(form);
  const label = btn.querySelector('.gv-deal__btn-t') || btn;
  const err = form.querySelector('.gv-deal__err');
  const T = btn.dataset;
  if (err) { err.hidden = true; err.textContent = ''; }
  btn.classList.add('is-busy');
  btn.setAttribute('aria-disabled', 'true');
  label.textContent = T.adding;

  const reset = (ms) => setTimeout(() => {
    label.textContent = T.add;
    btn.classList.remove('is-busy');
    btn.removeAttribute('aria-disabled');
    busy.delete(form);
  }, ms);
  const fail = (msg) => {
    if (err) { err.textContent = msg || T.error; err.hidden = false; setTimeout(() => { err.hidden = true; }, 10000); }
    reset(0);
  };

  const data = new FormData(form);
  const qty = Number(data.get('quantity')) || 1;
  const ids = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  const mini = window.GVMini && window.GVMini.openOnAdd ? window.GVMini : null;   // giỏ hàng nhanh (gv-minicart)
  if (mini) ids.push(mini.sectionId);
  if (ids.length) data.set('sections', ids.join(','));

  const Ev = await cartEvent();
  const deferred = Ev && Ev.createPromise ? Ev.createPromise() : null;
  if (deferred) {
    form.dispatchEvent(new Ev({
      action: 'add', context: 'product',
      lines: [{ merchandiseId: String(data.get('id')), quantity: qty }],
      promise: deferred.promise,
    }));
  }
  const settle = (cart, detail) => {
    if (!deferred) return;
    let c;
    try { c = cart && Ev.createCartFromAjaxResponse ? Ev.createCartFromAjaxResponse(cart) : undefined; } catch (_) { c = undefined; }
    deferred.resolve({ cart: c, detail: Object.assign({ items: cart ? cart.items : [], source: 'gv-deals', sourceId: form.id || '', productId: form.dataset.productId }, detail) });
  };
  const getCart = () => fetch((form.dataset.cart || '/cart').replace(/\/$/, '') + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).catch(() => null);

  try {
    const res = await fetch(form.action.replace(/\/$/, '') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data,
    });
    let json = {};
    try { json = await res.json(); } catch (_) {}
    if (!res.ok || json.status) {
      settle(await getCart(), { didError: true, itemCount: 0 });
      fail(json.description || json.message);
      return;
    }
    settle(await getCart(), { didError: false, itemCount: qty, sections: json.sections });
    label.textContent = T.added;
    reset(1000);
    if (mini) mini.open(json.sections && json.sections[mini.sectionId], btn);
  } catch (x) {
    settle(null, { didError: true, itemCount: 0 });
    fail();
  }
}, true);
